var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgElement(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Iconsax/Bold/element"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4583 20.7291V4.27075C11.4583 2.70825 10.7916 2.08325 9.13538 2.08325H4.92704C3.27079 2.08325 2.60413 2.70825 2.60413 4.27075V20.7291C2.60413 22.2916 3.27079 22.9166 4.92704 22.9166H9.13538C10.7916 22.9166 11.4583 22.2916 11.4583 20.7291ZM22.3958 11.3541V4.27075C22.3958 2.70825 21.7291 2.08325 20.0729 2.08325H15.8645C14.2083 2.08325 13.5416 2.70825 13.5416 4.27075V11.3541C13.5416 12.9166 14.2083 13.5416 15.8645 13.5416H20.0729C21.7291 13.5416 22.3958 12.9166 22.3958 11.3541ZM22.3958 20.7291V17.8124C22.3958 16.2499 21.7291 15.6249 20.0729 15.6249H15.8645C14.2083 15.6249 13.5416 16.2499 13.5416 17.8124V20.7291C13.5416 22.2916 14.2083 22.9166 15.8645 22.9166H20.0729C21.7291 22.9166 22.3958 22.2916 22.3958 20.7291Z",
    fill: "#313131"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElement);
export default __webpack_public_path__ + "static/media/element.4a8a04dc451dbecc48cad7a2576e4206.svg";
export { ForwardRef as ReactComponent };